import { render, staticRenderFns } from "./LectionDayAdd.vue?vue&type=template&id=4c820368&"
import script from "./LectionDayAdd.vue?vue&type=script&lang=js&"
export * from "./LectionDayAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports